import INVQUANT_EXT_1 from "./INVQUANT_EXT_1";
export default {
  INVQUANT_EXT_1,
};
